import android from './svg/android.svg';
import apple_color from './svg/apple_color.svg';
import facebook from './svg/facebook.svg';
import facebook_color from './svg/facebook_color.svg';
import google_color from './svg/google_color.svg';
import instagram from './svg/instagram.svg';
import tiktok from './svg/tiktok.svg';
import whatsapp from './svg/whatsapp.svg';
import whatsapp_square_color from './svg/whatsapp_color.svg';
import x_twitter_square from './svg/x_twitter.svg';

const svgs = {
  android,
  apple: apple_color,
  apple_color,
  google: google_color,
  google_color,
  facebook,
  facebook_color,
  instagram,
  whatsapp,
  whatsapp_square_color, // TODO: replace name with whatsapp_color
  tiktok,
  x_twitter_square, // TODO: replace name with x_twitter
};

export type SvgProvidersList = keyof typeof svgs;
export default svgs;
